import NS from './reducer-name.js';

const selectSupport = state => state[NS];

export default selectSupport;
